import React, { useContext } from 'react';
import { FloatingPortal } from '@floating-ui/react';
import PopoverContext from '../../context';

const DropdownContent = ({ children = null }) => {
  const { isVisible, refs, floatingStyles, getFloatingProps, width, zIndex, portalRootNode } =
    useContext(PopoverContext);

  if (!isVisible) {
    return null;
  }

  return (
    <FloatingPortal {...(portalRootNode && { root: portalRootNode })}>
      <div
        ref={refs.setFloating}
        className="ws-ui-dropdown-content"
        style={{ ...floatingStyles, width, zIndex }}
        {...getFloatingProps()}
      >
        {children}
      </div>
    </FloatingPortal>
  );
};

export default DropdownContent;
